export const MERCHANT_HOURS_ACTIONS = {
    SET_INITIAL_STATE: 'SET_INITIAL_STATE',
    SET_LAST_SAVE: 'SET_LAST_SAVE',
    SET_WORKING_DAY: 'SET_WORKING_DAY',
    TOGGLE_LOADING_STATE: 'TOGGLE_LOADING_STATE',
    SET_ERROR_STATE: 'SET_ERROR_STATE',
    DELETE_WORKING_DAY: 'DELETE_WORKING_DAY',
    SET_CALENDAR_EVENTS: 'SET_CALENDAR_EVENTS',
    SET_INITIAL_CALENDAR_EVENTS: 'SET_INITIAL_CALENDAR_EVENTS',
    DELETE_CALENDAR_EVENTS: 'DELETE_CALENDAR_EVENTS',
    SET_CURRENT_STORES: 'SET_CURRENT_STORES',
}